/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Spin,
  Card,
  Tabs,
  message,
} from 'antd';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  RedoOutlined,
} from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import { makeOnChangeTabKey } from 'utils/tabsManagement';
import { getModelPermission } from 'utils/permission';
import makeMessager from 'utils/complexFormsMessages';
import ModalDelete from 'components/ModalDelete';
import {
  getEstadosGlobales,
} from 'api/catalogos/index';
import {
  getConfiguracionIncidencias,
  postConfiguracionIncidencia,
  deleteConfiguracionIncidencia,
  patchConfiguracionIncidencia,
  getConfiguracionIncidencia,
  autorizarConfiguracionIncidencia,
} from 'api/nominas/incidencias/configuracionIncidencias';
import { getPercepciones } from 'api/nominas/percepciones/percepciones';
import { getCATSATPercepciones } from 'api/nominas/catalogos/CATSATPercepciones';
import { getTiposDeIncapacidades } from 'api/catalogos/tiposDeIncapacidad';
import { getTiposDeIncidencias } from 'api/nominas/incidencias/tiposIncidencias';
import { getTiposDeIncidenciasUnidades } from 'api/nominas/incidencias/tiposIncidenciasUnidades';
import { checkToken } from 'api/utils';
import {
  SLUG_PATTERN,
  FLOAT_NUMER_PATTERN,
  integerRegExp,
} from 'utils/patterns';
import {
  ESTATUS_ACTIVO,
  ESTATUS_INACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_CANCELADO,
  INCIDENCIA_AUSENTISMO,
  INCIDENCIA_VACACIONES,
} from 'utils/constants';
import ModalConfirmation from 'components/ModalConfirmation';
import IncidenciasGenerales from 'components/Nominas/Incidencias/Generales';
import IncidenciasParametros from 'components/Nominas/Incidencias/Parametros';
import IncidenciasCatalogosAdicionales from 'components/Nominas/Incidencias/CatalogosAdicionales';
import IncidenciasOtrosParametros from 'components/Nominas/Incidencias/IncidenciasOtrosParametros';
import IncidenciasTipoDeNomina, { incidenciasTipoNominaPermission } from './IncidenciasTiposDeNominas';
import IncidenciasTipoDeNominaEmpleado, { incidenciasTipoNominaEmpleadoPermission } from './IncidenciasTiposDeNominasEmpleados';

const { TabPane } = Tabs;
const baseURI = 'nominas/incidencias';

export const configuracionIncidenciaPermission = {
  permissionModel: 'incidencia',
  catalogsModels: [],
  tabsModels: [],
};

const ESTATUS_EDITABLES = [ESTATUS_ACTIVO, ESTATUS_INACTIVO];

const onErrorFields = (
  err,
  setLoading = null,
  formsInstances = [],
  setCurrentTabKey,
) => {
  if (typeof setLoading === 'function') {
    setLoading(false);
  }
  const errorKeys = err.errorFields.map((e) => e.name[0]);
  const formWithErrors = formsInstances.find(
    (obj) => obj.tabFields.some(
      (val) => errorKeys.includes(val),
    ),
  );
  if (formWithErrors) {
    setTimeout(() => {
      if (typeof setCurrentTabKey === 'function') {
        setCurrentTabKey(formWithErrors.tabKey);
      }
    });
  }
};

const ConfiguracionIncidencias = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [currentTabKey, setCurrentTabKey] = useState('general');
  const [mutable, setMutable] = useState(true);
  const [estados, setEstados] = useState([]);
  const [estadosFiltered, setEstadosFiltered] = useState([]);
  const [percepciones, setPercepciones] = useState([]);
  const [catsatPercepciones, setCatsatPercepciones] = useState([]);
  const [incapacidades, setIncapacidades] = useState([]);
  const [tiposDeInicidencias, setTiposDeIncidencias] = useState([]);
  const [tiposDeInicidenciasUnidades, setTiposDeIncidenciasUnidades] = useState([]);
  const [aplicaPorcentaje, setAplicaPorcentaje] = useState(false);
  const [tipoIncidencia, setTipoIncidencia] = useState();
  const [selectedPercepciones, setSelectedPercepciones] = useState(null);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [visibleCancelar, setVisibleCancelar] = useState(false);
  const [visibleReactivar, setVisibleReactivar] = useState(false);
  const [disableEdit, setDisableEdit] = useState(false);
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [disableOnTipoIncidencia, setDisableOnTipoIncidencia] = useState(false);
  const [aplicaCatalogosAdicionales, setAplicaCatalogosAdicionales] = useState(false);
  const [disableTable, setDisableTable] = useState(false);

  const requiredFormStructure = [
    {
      parentTabKey: 'general',
      tabKey: 'general',
      tabFields: ['clave', 'concepto', 'tipo_de_incidencia',
        'tipo_incapacidad_nomina', 'tipo_de_incidencia_unidad', 'estados_globales'],
    },
    {
      parentTabKey: 'parametros',
      tabKey: 'parametros',
      tabFields: ['aparece_en_recibo_de_nomina', 'aplica_pago', 'aplica_descuento', 'se_suspende_el_pago_de_sueldo',
        'cuenta_como_dias_laborados', 'aplica_porcentaje_de_sueldo_a_pagar',
        'requiere_datos_informativos', 'aplica_porcentaje_de_sueldo',
        'requiere_numero_de_horas_de_la_jornada',
        'requiere_sueldo_por_dia',
        'requiere_sueldo_por_hora',
        'requiere_numero_de_veces_de_pago',
        'requiere_importe_de_pago',
        'se_considera_descuento_en_nomina',
        'requiere_importe_de_descuento',
        'es_suspension_del_empleado',
        'requiere_fecha_final_abierta',
        'requiere_folio_agrupador'],
    },
  ];

  const basicKeys = [
    'general',
    'parametros',
    'catalogos',
  ];

  const complexForms = [];

  const formInstances = [
    form,
  ];

  const getPermissionEmpleados = getModelPermission(
    incidenciasTipoNominaEmpleadoPermission.permissionModel,
    incidenciasTipoNominaEmpleadoPermission.catalogsModels,
    incidenciasTipoNominaEmpleadoPermission.tabsModels,
    false,
  );

  const getPermissionNominas = getModelPermission(
    incidenciasTipoNominaPermission.permissionModel,
    incidenciasTipoNominaPermission.catalogsModels,
    incidenciasTipoNominaPermission.tabsModels,
    false,
  );

  const fetchData = async () => {
    setLoading(true);
    const _data = await getConfiguracionIncidencias();
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _percepciones,
        _catsatPercepciones,
        _incapacidades,
        _tiposDeInicidencias,
        _tiposDeIncidenciasUnidades,
        _data,
      ] = await Promise.all([
        getEstadosGlobales(),
        getPercepciones({ es_incidencia: true }),
        getCATSATPercepciones(),
        getTiposDeIncapacidades(),
        getTiposDeIncidencias(),
        getTiposDeIncidenciasUnidades(),
        getConfiguracionIncidencias(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setEstadosFiltered(_estados?.filter((e) => ESTATUS_EDITABLES.includes(e?.id)));
        setPercepciones(_percepciones);
        setCatsatPercepciones(_catsatPercepciones);
        setIncapacidades(_incapacidades);
        setTiposDeIncidencias(_tiposDeInicidencias);
        setTiposDeIncidenciasUnidades(_tiposDeIncidenciasUnidades);
        setData(formatReceived(_data));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setSelectedRowKeys([]);
    setVisible(false);
    setMutable(true);
    setAplicaPorcentaje(false);
    setCurrentTabKey('general');
    setTipoIncidencia();
    setSelectedPercepciones();
    setEstadosFiltered(estados?.filter((e) => ESTATUS_EDITABLES.includes(e?.id)));
    setVisibleAutorizar(false);
    setVisibleCancelar(false);
    setVisibleReactivar(false);
    setDisableEdit(false);
    setDisableTable(false);
    setAplicaCatalogosAdicionales(false);
    setDisableOnTipoIncidencia(false);
    form.resetFields();
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _incidencia = await getConfiguracionIncidencia(match.id);
    setTimeout(() => {
      if (_incidencia) {
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(_incidencia));
          setAplicaPorcentaje(_incidencia?.aplica_porcentaje_de_sueldo_a_pagar);
          setTipoIncidencia(_incidencia?.tipo_de_incidencia);
          setSelectedPercepciones(_incidencia?.tipo_de_incidencia);
          setAplicaCatalogosAdicionales(_incidencia?.aplica_catalogos_adicionales);
          if (_incidencia?.estados_globales === ESTATUS_AUTORIZADO) {
            setEstadosFiltered(estados?.filter((e) => e?.id === ESTATUS_AUTORIZADO));
          }
          if (_incidencia?.tipo_de_incidencia === INCIDENCIA_AUSENTISMO
            || _incidencia?.tipo_de_incidencia === INCIDENCIA_VACACIONES) {
            setDisableOnTipoIncidencia(true);
          }
          setDisableEdit(_incidencia?.estados_globales !== ESTATUS_ACTIVO);
          setDisableTable(_incidencia?.estados_globales !== ESTATUS_ACTIVO
            && _incidencia?.estados_globales !== ESTATUS_AUTORIZADO);
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = true) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = {
        ...form.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len
      const saved = await (key ? patchConfiguracionIncidencia(key, values) : postConfiguracionIncidencia(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      if (err.errorFields) {
        onErrorFields(
          err,
          setLoading,
          requiredFormStructure,
          setCurrentTabKey,
        );
        message.warn('Favor de corregir los errores señalados');
      } else {
        onError(
          err,
          setLoading,
          formInstances,
        );
      }
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteConfiguracionIncidencia(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
    setAplicaCatalogosAdicionales(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const showMsg = makeMessager(setCurrentTabKey);

  const onChangeTabKey = makeOnChangeTabKey(
    basicKeys,
    complexForms,
    currentTabKey,
    setCurrentTabKey,
    showMsg,
  );

  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar una incidencia ya autorizada');
        return;
      }
      const saved = await autorizarConfiguracionIncidencia(key);
      if (saved) {
        const _data = await getConfiguracionIncidencias();
        setData(formatReceived(_data));
        setVisibleAutorizar(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onConfirmCancelar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        return;
      }
      const saved = await patchConfiguracionIncidencia(key, { estados_globales: ESTATUS_CANCELADO });
      if (saved) {
        const _data = await getConfiguracionIncidencias();
        setData(formatReceived(_data));
        setVisibleCancelar(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onConfirmReactivar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        return;
      }
      const saved = await patchConfiguracionIncidencia(key, { estados_globales: ESTATUS_ACTIVO });
      if (saved) {
        const _data = await getConfiguracionIncidencias();
        setData(formatReceived(_data));
        setVisibleReactivar(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
    },
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 120,
    },
    {
      titleText: 'Concepto',
      dataIndex: 'concepto',
      key: 'concepto',
      width: 300,
    },
    {
      titleText: 'Fundamento',
      dataIndex: 'fundamento',
      key: 'fundamento',
      width: 300,
    },
    {
      titleText: 'Tipo de Incidencia',
      dataIndex: 'tipo_de_incidencia',
      key: 'tipo_de_incidencia',
      width: 200,
      render: (val) => tiposDeInicidencias.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: 'Percepción',
      dataIndex: 'percepcion',
      key: 'percepcion',
      width: 250,
      render: (val) => {
        const _percepcion = percepciones.find((e) => e.id === val);
        return (_percepcion?.clave ? `${_percepcion?.clave} - ${_percepcion?.descripcion}` : '');
      },
    },
    {
      titleText: 'Concepto de Ingreso SAT',
      dataIndex: 'catsat_percepcion',
      key: 'catsat_percepcion',
      width: 300,
      render: (val) => {
        const _concepto = catsatPercepciones.find((e) => e.id === val);
        return (_concepto?.clave ? `${_concepto?.clave} - ${_concepto?.descripcion}` : '');
      },
    },
    {
      titleText: 'Tipo de Incapacidad SAT',
      dataIndex: 'tipo_incapacidad_nomina',
      key: 'tipo_incapacidad_nomina',
      width: 220,
      render: (val) => {
        const _incapacidades = incapacidades.find((e) => e.id === val);
        return (_incapacidades?.clave ? `${_incapacidades?.clave} - ${_incapacidades?.descripcion}` : '');
      },
    },
    {
      titleText: 'Unidad de Incidencia',
      dataIndex: 'tipo_de_incidencia_unidad',
      key: 'tipo_de_incidencia_unidad',
      width: 200,
      render: (val) => tiposDeInicidenciasUnidades.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: 'Aparece en Recibo',
      dataIndex: 'aparece_en_recibo_de_nomina',
      key: 'aparece_en_recibo_de_nomina',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Aplica Pago',
      dataIndex: 'aplica_pago',
      key: 'aplica_pago',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Aplica Descuento',
      dataIndex: 'aplica_descuento',
      key: 'aplica_descuento',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Se Suspende Pago de Sueldo',
      dataIndex: 'se_suspende_el_pago_de_sueldo',
      key: 'se_suspende_el_pago_de_sueldo',
      width: 240,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Descontar Días Laborados',
      dataIndex: 'aplica_restar_de_dias_laborados',
      key: 'aplica_restar_de_dias_laborados',
      width: 250,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Descontar Días Laborados CFDI',
      dataIndex: 'aplica_restar_de_dias_laborados_cfdi',
      key: 'aplica_restar_de_dias_laborados_cfdi',
      width: 250,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Cuentan como Días Laborados',
      dataIndex: 'cuenta_como_dias_laborados',
      key: 'cuenta_como_dias_laborados',
      width: 250,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Aplica Datos Informativos',
      dataIndex: 'requiere_datos_informativos',
      key: 'requiere_datos_informativos',
      width: 220,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Aplica la Evaluación de Reloj Checador',
      dataIndex: 'aplica_para_evaluacion_de_reloj_checador',
      key: 'aplica_para_evaluacion_de_reloj_checador',
      width: 220,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Observaciones',
      dataIndex: 'observaciones',
      key: 'observaciones',
      width: 400,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    contratacion: [requiredRule],
    estatus: [requiredRule],
    clave: [
      requiredRule,
      {
        pattern: SLUG_PATTERN,
        message: 'Ingrese una clave válida',
      },
    ],
    valor: [
      requiredRule,
      {
        pattern: FLOAT_NUMER_PATTERN,
        message: 'Ingrese un valor válido',
      },
    ],
    numeros: [
      requiredRule,
      {
        pattern: integerRegExp,
        message: 'Ingrese un valor válido',
      },
    ],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Table
            cols={columns}
            data={data}
            titleTable="Incidencias"
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            customActions={[
              {
                onClick: () => setVisibleAutorizar(true),
                permission: { model: 'incidencia', action: 'autorizar' },
                text: 'Autorizar',
                icon: <CheckCircleOutlined />,
                className: 'success',
                disabledBySelection: false,
                disabled: data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales !== ESTATUS_ACTIVO,
              },
              {
                onClick: () => setVisibleCancelar(true),
                permission: { model: 'incidencia', action: 'cancelar' },
                text: 'Cancelar',
                icon: <CloseCircleOutlined />,
                className: 'cancel',
                disabledBySelection: false,
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO,
              },
              {
                onClick: () => setVisibleReactivar(true),
                permission: { model: 'incidencia', action: 'reactivar' },
                text: 'Reactivar',
                icon: <RedoOutlined />,
                className: 'success',
                disabledBySelection: false,
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_ACTIVO,
              },
            ]}
            disableDelete={data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO}
            baseURI={baseURI}
            allowImport
            permission={permission}
          />
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Incidencia`}
            extra={(
              <FormSubmitControls
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
                onFinishText="Guardar y Continuar"
                mutable={!disableEdit}
              />
            )}
            bordered={false}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstError
              name="general"
              initialValues={{
                aparece_en_recibo_de_nomina: false,
                aplica_pago: false,
                aplica_descuento: false,
                se_suspende_el_pago_de_sueldo: false,
                aplica_restar_de_dias_laborados: false,
                aplica_restar_de_dias_laborados_cfdi: false,
                cuenta_como_dias_laborados: false,
                aplica_porcentaje_de_sueldo: false,
                aplica_porcentaje_de_sueldo_a_pagar: false,
                requiere_datos_informativos: false,
                aplica_para_evaluacion_de_reloj_checador: false,
                requiere_numero_de_horas_de_la_jornada: false,
                requiere_sueldo_por_dia: false,
                requiere_sueldo_por_hora: false,
                requiere_numero_de_veces_de_pago: false,
                requiere_importe_de_pago: false,
                requiere_importe_de_descuento: false,
                se_descuenta_de_percepcion: false,
                se_considera_descuento_en_nomina: false,
                aplica_tipo_de_empleado: false,
                aplica_tipo_contratacion_empleado: false,
                aplica_a_sindicalizados: false,
                aplica_antiguedad_laboral_minima: false,
                aplica_antiguedad_minima_sindicalizado: false,
                aplica_limite_de_dias: false,
                aplica_corte_de_dias_por_ano: false,
                se_desasigna_la_plaza: false,
                aplica_cambio_estatus_empleado: false,
                estados_globales: 1,
              }}
            >
              <Tabs
                activeKey={currentTabKey}
                onChange={mutable ? onChangeTabKey : setCurrentTabKey}
                type="card"
              >
                <TabPane
                  tab="General"
                  key="general"
                  forceRender
                >
                  <IncidenciasGenerales
                    form={form}
                    rules={rules}
                    selectedRowKeys={selectedRowKeys}
                    estados={estadosFiltered}
                    percepciones={percepciones}
                    catsatPercepciones={catsatPercepciones}
                    incapacidades={incapacidades}
                    tiposIncidencias={tiposDeInicidencias}
                    tiposIncidenciasUnidades={tiposDeInicidenciasUnidades}
                    tipoIncidencia={tipoIncidencia}
                    setTipoIncidencia={setTipoIncidencia}
                    setSelectedPercepciones={setSelectedPercepciones}
                    disabled={disableEdit}
                    setVisibleConfirmInactivo={setVisibleConfirmInactivo}
                    disableOnTipoIncidencia={disableOnTipoIncidencia}
                    setDisableOnTipoIncidencia={setDisableOnTipoIncidencia}
                    setAplicaCatalogosAdicionales={setAplicaCatalogosAdicionales}
                  />
                  {selectedRowKeys.length
                    ? (
                      <>
                        <p style={{ fontWeight: 600, marginBottom: 0, color: '#D88F4F' }}>Tipo de Nómina</p>
                        <IncidenciasTipoDeNomina
                          permission={getPermissionNominas}
                          selected={selectedRowKeys[0]}
                          disabled={disableTable}
                        />
                      </>
                    ) : null}
                  {selectedRowKeys.length
                    ? (
                      <>
                        <p style={{ fontWeight: 600, marginBottom: 0, color: '#D88F4F' }}>Tipo de Nómina Empleado</p>
                        <IncidenciasTipoDeNominaEmpleado
                          permission={getPermissionEmpleados}
                          selected={selectedRowKeys[0]}
                          disabled={disableTable}
                        />
                      </>
                    ) : null}
                </TabPane>
                <TabPane
                  tab="Parámetros"
                  key="parametros"
                  forceRender
                >
                  <IncidenciasParametros
                    form={form}
                    rules={rules}
                    aplicaPorcentaje={aplicaPorcentaje}
                    setAplicaPorcentaje={setAplicaPorcentaje}
                    selectedPercepciones={selectedPercepciones}
                    disabled={disableEdit}
                    incidenciaId={selectedRowKeys[0]}
                  />
                </TabPane>
                <TabPane
                  tab="Catálogos Adicionales"
                  key="catalogos"
                  forceRender
                >
                  <IncidenciasCatalogosAdicionales
                    form={form}
                    idParent={selectedRowKeys}
                    rules={rules}
                    disabled={disableEdit}
                    aplicaCatalogosAdicionales={aplicaCatalogosAdicionales}
                    setAplicaCatalogosAdicionales={setAplicaCatalogosAdicionales}
                  />
                </TabPane>
                <TabPane
                  tab="Otros Parámetros"
                  key="otros_parametros"
                  forceRender
                >
                  <IncidenciasOtrosParametros
                    form={form}
                    rules={rules}
                    disabled={disableEdit}
                  />
                </TabPane>
              </Tabs>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Incidencia ${form.getFieldValue('clave')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          onCancel={() => setVisibleAutorizar(false)}
          open={visibleAutorizar}
          ConfirmAutorize
          contentTitle={`Autorizar la Incidencia ${form.getFieldValue('clave')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmCancelar}
          onCancel={() => setVisibleCancelar(false)}
          open={visibleCancelar}
          ConfirmCancel
          contentTitle={`Cancelar la Incidencia ${form.getFieldValue('clave')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmReactivar}
          onFinishText="Reactivar"
          onFinishIcon={<RedoOutlined />}
          onCancel={() => setVisibleReactivar(false)}
          open={visibleReactivar}
          contentTitle={`Reactivar la Incidencia ${form.getFieldValue('clave')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={() => setVisibleConfirmInactivo(false)}
          onCancel={() => {
            form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
            setVisibleConfirmInactivo(false);
          }}
          open={visibleConfirmInactivo}
          ConfirmInactive
          contentTitle={`Inactivar la Incidencia ${form.getFieldValue('clave')}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default ConfiguracionIncidencias;
